<script setup lang="ts">
const deliveryAndReturns = inject('deliveryAndReturns')
</script>

<template>
  <LazyUiDialog
    name="delivery-and-returns-dialog"
    dialog-type="responsive"
  >
    <template #dialogHeader>
      <span class="dialog__title">{{ deliveryAndReturns.Title }}</span>
    </template>

    <StrapiBlocksText
      v-if="deliveryAndReturns?.Richtext"
      :nodes="deliveryAndReturns.Richtext"
    />

    <!-- <pre>{{ deliveryAndReturns.Richtext }}</pre> -->
  </LazyUiDialog>
</template>
